import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { IconModule } from '@pu/ui';

import { SelectDropdownListComponent } from './select-dropdown-list.component';

@NgModule({
  imports: [CommonModule, IconModule, TranslateModule],
  declarations: [SelectDropdownListComponent],
  exports: [SelectDropdownListComponent],
})
export class SelectDropdownListComponentModule {}
